import React from "react";
import { HelloBar } from "../../ui/HelloBar";
import { currentLanguage } from "@src/utils/routes";
import { useLocation } from "@reach/router";

const LOCALES = ["en-us"];

interface DistrictsHelloBarProps {
  zIndex?: number;
}

const DistrictsHelloBar = ({ zIndex }: DistrictsHelloBarProps) => {
  const location = useLocation();
  const lang = currentLanguage();

  // Only show on main index page
  if (location.pathname !== "/") return null;
  if (!LOCALES.includes(lang)) return null;

  return (
    <HelloBar
      cookieName="school_leaders"
      to="/school-leaders/?utm_source=hellobar"
      text="Everything school leaders need to engage families—free and ready to go."
      trackingEventName="web.external.school_leaders.hello_bar.click"
      css={{ zIndex }}
    />
  );
};

export default DistrictsHelloBar;
